import React from 'react';
import Navbar from './components/navbar';
import About from './components/about';
import Experience from './components/exp';
import Projects from './components/projects';
import Skills from './components/skills';
import Contact from './components/contact';
import styled from 'styled-components';

const AppContainer = styled.div`
  background-color: rgb(46, 57, 80);
  padding: 30px;
`;

function App() {
  return (

    <AppContainer>
      <Navbar />
      <About />
      <Experience />
      <Projects />
      <Skills />
      <Contact />
    </AppContainer>

  );
}


export default App;
